module.exports = __webpack_public_path__ + "static/mountains-beyond-mountains-b21d7ffeb6dff45f9c770348d068da3b.jpg";